import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useOutlet } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, resetRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import ChatAlertModal from "../components/modal/ChatAlertModal";
import ChatDetailModal from "../components/modal/ChatDetailModal";
import NoticeModal from "../components/modal/NoticeModal";
import DirectMessageController, {
  ChatDetailType,
} from "../controller/DirectMessageController";
import LogController from "../controller/LogController";
import {
  authState,
  authType,
  currentStoreState,
  CurrentStoreType,
  versionState,
} from "../recoil/auth";
import {
  chatFinishedState,
  chatListType,
  chatState,
  chatType,
  newChatListState,
} from "../recoil/chat";
import { noticeState } from "../recoil/notice";
import { urlState } from "../recoil/url";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";
import {
  connectState,
  connectType,
  refreshAppState,
} from "./socket/socketState";
import { pushSettingState } from "../recoil/sound";
import PosController from "../controller/PosController";
import CouponModal from "../components/modal/CouponModal";

let oWindow: Window | null = null;
let authInterval: any = null;

let chatAlertTimer: any;

export const AllLayout = (oProps: any) => {
  const outlet = useOutlet();
  const auth = useRecoilValue<authType>(authState);

  const [isConfirm, setIsConfirm] = useState<boolean>(false);
  const [visibleChatAlert, setVisibleChatAlert] = useState<boolean>(false);
  const [chatStateFlag, setChatStateFlag] = useRecoilState<chatType>(chatState);
  const [chatDetail, setChatDetail] = useState<ChatDetailType[]>([]);

  const [url, setUrl] = useRecoilState<string | null>(urlState);
  const [isNotice, setIsNotice] = useRecoilState<boolean>(noticeState);

  const isConnect = useRecoilValue<connectType>(connectState);
  const refreshApp = useRecoilValue<boolean>(refreshAppState);

  const chatFinishedFlag = useRecoilValue<boolean>(chatFinishedState);
  const newChatListFlag = useRecoilValue<chatListType[]>(newChatListState);

  const currentStore = useRecoilValue<CurrentStoreType>(currentStoreState);

  const [visibleCoupon, setVisibleCoupon] = useState<boolean>(false);

  const cancelAudio = new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/error_bell.mp3`
  );
  const chatAudio = new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/msg_bell.mp3`
  );

  const getChats = async () => {
    try {
      const oParams = {
        cs_id: chatStateFlag.chat_id,
        lang: 0,
        reader_type: "STORE",
      };
      const oResponse = await DirectMessageController.getChats(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setChatDetail([...oRes.data.chats]);

          if (chatStateFlag.direct_open) {
            setChatStateFlag({
              ...chatStateFlag,
              visible: true,
              direct_open: false,
            });
          }
        }
      }
    } catch (e) {
      console.error("err => ", e);
    }
  };

  const openChat = () => {
    setChatStateFlag((prev) => ({
      ...prev,
      chat_id: chatStateFlag.cs_id,
      direct_open: true,
    }));
    console.log("newChatListState", getRecoil(newChatListState), chatStateFlag);
    setRecoil(newChatListState, (prev) => [
      ...prev.filter((item) => !(item.cs_id === chatStateFlag.cs_id)),
    ]);
    setVisibleChatAlert(false);
  };

  // const exitManage = () => {
  //   setIsConfirm(false);
  //   setUrl(null);
  //   console.log("out");
  // };

  const setPosConfig = async () => {
    try {
      let settingTemp: any = {};

      const pushSetting = await AsyncLocalStorage.getItem("pushSetting");
      if (pushSetting) {
        settingTemp.push_setting = pushSetting;
      }
      const deliverySetting = await AsyncLocalStorage.getItem(
        "deliverySetting"
      );
      if (deliverySetting) {
        settingTemp.delivery_setting = deliverySetting;
      }
      const detailSetting = await AsyncLocalStorage.getItem("detailSetting");

      if (detailSetting) {
        settingTemp.detail_setting = detailSetting;
      }

      const oRes = await PosController.setPosConfig(settingTemp);

      if (oRes && oRes.data) {
        const response = oRes.data;

        if (response.ok) {
          console.log("setPosConfig", response.data);
        }
      }
    } catch (e) {
      console.error("setPosConfig error => ", e);
    }
  };

  const posUpdateCheckFor096 = async () => {
    try {
      const oRes = await PosController.posUpdateCheckFor096();

      if (oRes && oRes.data) {
        const response = oRes.data;

        console.log("posUpdateCheckFor096", response.data);

        if (response.data && response.data.is_update) {
          if (window && window.parent) {
            window.parent.postMessage(
              JSON.stringify({
                action: "logout_user",
                data: "update",
              }),
              "*"
            );
          }
        }
      }
    } catch (e) {
      console.error("posUpdateCheckFor096 error => ", e);
    }
  };

  const versionDelayCheck = async () => {
    const settingTemp = AsyncLocalStorage.getItem("pushSetting");
    if (settingTemp && !settingTemp.delay) {
      const updatedSetting = { ...settingTemp, delay: 3 };
      console.log("prevVersion", updatedSetting);
      await AsyncLocalStorage.setItem(
        "pushSetting",
        JSON.stringify(updatedSetting)
      );
    }
  };

  const playCancelAudio = () => {
    if (cancelAudio && !isConnect.type && !isConnect.is_first) {
      setTimeout(() => {
        cancelAudio.currentTime = 0;
        cancelAudio.play();
      }, 5000);
    }
  };

  const playChatAlertAudio = () => {
    if (chatAudio) {
      chatAlertTimer = setTimeout(() => {
        chatAudio.currentTime = 0;
        chatAudio.play();
      }, 5000);
    }
  };

  useEffect(() => {
    versionDelayCheck();

    // const handleKey = (event: KeyboardEvent) => {
    //   if (event.key === "Escape") {
    //     setIsConfirm(true);
    //   }
    // };
    // window.addEventListener("keydown", handleKey);
    // return () => {
    //   window.removeEventListener("keydown", handleKey);
    // };
    LogController.event({
      path: "Refresh",
      params: "화면 불러오기 or 새로고침",
      params2: "",
    });
  }, []);

  useEffect(() => {
    if (refreshApp) {
      console.log("refresh App!!!");
      window.location.reload();
      setRecoil(refreshAppState, false);
      toast.success("주문 목록을 새로고침했어요");
    }
  }, [refreshApp]);

  // useEffect(() => {
  //   if (cancelAudio && !isConnect.type && !isConnect.is_first) {
  //     cancelAudio.currentTime = 0;
  //     cancelAudio.play();

  //     cancelAudio.addEventListener("ended", playCancelAudio);
  //   } else {
  //     if (cancelAudio) {
  //       cancelAudio.pause();
  //       cancelAudio.currentTime = 0;
  //     }
  //   }
  //   return () => {
  //     cancelAudio.removeEventListener("ended", playCancelAudio);
  //   };
  // }, [isConnect]);

  useEffect(() => {
    if (!chatStateFlag.visible) {
      setChatStateFlag((prev) => ({ ...prev, chat_id: chatStateFlag.cs_id }));
    }
  }, [chatStateFlag.visible]);

  useEffect(() => {
    if (chatStateFlag.cs_id) {
      if (chatStateFlag.chat_id) {
        getChats();
      }
    }
  }, [chatStateFlag.chat_id, chatStateFlag.date]);

  useEffect(() => {
    if (
      chatStateFlag.cs_id &&
      !chatStateFlag.visible &&
      !visibleChatAlert &&
      !chatFinishedFlag
    ) {
      setVisibleChatAlert(true);
      LogController.event({
        path: "Chat alert",
        params: "새로운 채팅 알림",
        params2: chatStateFlag.cs_id.toString(),
      });
    }
  }, [chatStateFlag.date]);

  useEffect(() => {
    if (chatStateFlag.visible) {
      setRecoil(newChatListState, (prev) => [
        ...prev.filter((item) => !(item.cs_id === chatStateFlag.cs_id)),
      ]);
    }
  }, [chatDetail]);

  useEffect(() => {
    if (url !== null) {
      oWindow = window.open(
        `${process.env.REACT_APP_API_CEO_URL}/posLogin`,
        "_blank",
        `width=${window.innerWidth},height=${window.innerHeight}`
      );

      const data = {
        type: url,
        data: auth,
      };
      let checkCount = 0;
      if (
        oWindow &&
        !oWindow.closed &&
        authInterval === null &&
        checkCount < 10
      ) {
        authInterval = setInterval(() => {
          console.log("open test");
          if (checkCount > 9) {
            clearInterval(authInterval);
            authInterval = null;
          }
          if (oWindow) {
            oWindow.postMessage(data, "*");
            checkCount++;
          }
        }, 500);
      }

      const checkIfClosed = setInterval(() => {
        if (oWindow === null || (oWindow && oWindow.closed)) {
          clearInterval(checkIfClosed);
          setUrl(null);
          console.log("New window was closed");
        }
      }, 1000);

      console.log("send Data", data);
    }
  }, [url]);

  useEffect(() => {
    if (chatFinishedFlag) {
      toast.success("상담이 종료되었습니다");
      resetRecoil(chatState);
      resetRecoil(chatFinishedState);
    }
  }, [chatFinishedFlag]);

  useEffect(() => {
    window.parent.postMessage(
      JSON.stringify({
        action: "get_chat_length",
        data: {
          chat_count: newChatListFlag.length,
        },
      }),
      "*"
    );
  }, [newChatListFlag, chatState]);

  useEffect(() => {
    if (auth && auth.refresh_token.length > 0) {
      setPosConfig();
      posUpdateCheckFor096();
    }
  }, [auth]);

  useEffect(() => {
    const handleCheckAuthMsg = (event: any) => {
      if (event && event.data && event.data.type === "check_auth") {
        console.log("check Auth");
        clearInterval(authInterval);
        authInterval = null;
      }
    };
    window.addEventListener("message", handleCheckAuthMsg);

    return () => {
      window.removeEventListener("message", handleCheckAuthMsg);
    };
  }, []);

  useEffect(() => {
    if (visibleChatAlert) {
      if (getRecoil(versionState).length === 0) {
        if (chatAudio) {
          chatAudio.currentTime = 0;
          chatAudio.play();
        }
      } else {
        window.parent.postMessage(
          JSON.stringify({
            action: "audio",
            data: {
              type: "chat",
              audio: `${process.env.PUBLIC_URL}/knockknock/audio/msg_bell.mp3`,
              volume: getRecoil(pushSettingState).volume,
              count: 10000,
              audio_delay: 5,
              play_status: true,
            },
          }),
          "*"
        );
      }

      chatAudio.addEventListener("ended", playChatAlertAudio);
    } else {
      clearTimeout(chatAlertTimer);
      chatAlertTimer = null;
      window.parent.postMessage(
        JSON.stringify({
          action: "audio",
          data: {
            type: "chat",
            audio: `${process.env.PUBLIC_URL}/knockknock/audio/msg_bell.mp3`,
            volume: getRecoil(pushSettingState).volume,
            count: 0,
            audio_delay: 5,
            play_status: false,
          },
        }),
        "*"
      );
    }
    return () => {
      cancelAudio.removeEventListener("ended", playChatAlertAudio);
    };
  }, [visibleChatAlert]);

  return (
    <>
      <Style>
        <div className="screen">{outlet}</div>
        {!isConnect.type && !isConnect.is_first && (
          <>
            <div className="toastWrap">
              <div className="customToastWrap">
                <div className="customToast">
                  <p className="toastMessage">네트워크 연결을 확인해주세요</p>
                </div>
              </div>
            </div>
          </>
        )}
      </Style>
      {/* <ConfirmModal
        isVisible={isConfirm}
        setVisible={setIsConfirm}
        title={"관리페이지를 나가시겠어요?"}
        confirmText="나가기"
        cancelText="취소"
        onConfirm={exitManage}
      /> */}
      <ChatAlertModal
        isVisible={visibleChatAlert}
        setVisible={setVisibleChatAlert}
        onConfirm={openChat}
      />
      <ChatDetailModal
        isVisible={chatStateFlag}
        chatDetail={chatDetail}
        setChatDetail={setChatDetail}
        status={0}
      />
      <NoticeModal isVisible={isNotice} setVisible={setIsNotice} />
      <CouponModal />
    </>
  );
};

export const Style = styled.div`
  .toastWrap {
    width: 100dvw;
    height: 100dvh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 9999999;
    .customToastWrap {
      height: 100dvh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .customToast {
      max-width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;
      text-align: left;
      border-radius: 10px;
      background: #ffffff;
    }
    .toastMessage {
      font-size: 20px;
      margin: 0;
      margin-left: 18px;
      font-weight: 500;
      color: #555555;
    }
  }

  audio {
    display: none;
  }

  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }
  .closeIcon {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 50px;
    margin: 0;
    z-index: 1000000;
    cursor: pointer;
    img {
      width: 32px;
      height: 32px;
    }
  }
`;
